import React, { useState } from 'react'
import './Explore_Programs.css'
import Common_title from '../../common_components/common-title/Common_title'
import { Nav, Tab } from 'react-bootstrap'
import Enquiry_Form_Modal from '../../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal'

const Explore_Programs = () => {

    const [activeTab, setActiveTab] = useState("Online_Degree");
    const [showModal, setShowModal] = useState(false)

    const data = [
        {
            course: "MBA",
            text: "Certificate Programme in ",
            text2: "Digital Marketing",
            img: "/assets/images/home/explore_program/img1.png"
        },
        {
            course: "BBA",
            text: "Bachelor of Business ",
            text2: "Administration",
            img: "/assets/images/home/explore_program/img2.png"
        },
        {
            course: "CPDM",
            text: "Certificate Programme in ",
            text2: "Digital Marketing",
            img: "/assets/images/home/explore_program/img3.png"
        },
        {
            course: "CPHAHM",
            text: "Certificate Programme in Hospital ",
            text2: "& Health Care Management",
            img: "/assets/images/home/explore_program/img4.png"
        },
    ]

    return (
        <section className='Explore_Programs'>
            <div className='container'>
                <Common_title title="Explore Our Programs" subtitle="Built for the Real World, Backed by Academic Excellence" />

                <div className='main_content_holder'>
                    <Tab.Container
                        id="left-tabs-example"
                        className="faq_tabs_container"
                        activeKey={activeTab}
                        onSelect={(key) => setActiveTab(key)}
                    >
                        <div>
                            <div className="">
                                <Nav variant="pills" className="all_tabs_holder" fill>
                                    <Nav.Item className='tab_holder'>
                                        <Nav.Link eventKey="Online_Degree" className="tab_btn">
                                            Online Degree
                                        </Nav.Link>
                                    </Nav.Item>

                                    <Nav.Item className='tab_holder'>
                                        <Nav.Link eventKey="Certification_Programs" className="tab_btn">
                                            Certification Programs
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                            <div>
                                <Tab.Content>
                                    <Tab.Pane eventKey="Online_Degree">
                                        <div className='row'>
                                            {data?.map((item) => {
                                                return (
                                                    <div className='col-lg-3 col-md-4 col-sm-6 mb-3'>
                                                        <div className='course_card' onClick={() => { setShowModal(true) }}>
                                                            <div className='img_holder'>
                                                                <img src={process.env.PUBLIC_URL + item?.img} className='img' />
                                                            </div>
                                                            <div className='text_holder'>
                                                                <p className='course'>{item?.course}</p>
                                                                <p className='text'>{item?.text}</p>
                                                                <p className='text'>{item?.text2}</p>
                                                            </div>
                                                            <div className='overlay'></div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Tab.Pane>

                                    <Tab.Pane eventKey="Certification_Programs">
                                        <div className='row'>
                                            {data?.map((item) => {
                                                return (
                                                    <div className='col-lg-3 mb-3'>
                                                        <div className='course_card' onClick={() => { setShowModal(true) }}>
                                                            <div className='img_holder'>
                                                                <img src={process.env.PUBLIC_URL + item?.img} className='img' />
                                                            </div>
                                                            <div className='text_holder'>
                                                                <p className='course'>{item?.course}</p>
                                                                <p className='text'>{item?.text}</p>
                                                                <p className='text'>{item?.text2}</p>
                                                            </div>
                                                            <div className='overlay'></div>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </Tab.Container>
                </div>

                <Enquiry_Form_Modal
                    show={showModal}
                    onHide={() => { setShowModal(false) }}
                />
            </div>
        </section>
    )
}

export default Explore_Programs
